import { useCurrentStateAndParams } from '@uirouter/react';

import { useUnauthorizedRedirect } from '@/react/hooks/useUnauthorizedRedirect';
import { PolicyOverrideAlert } from '@/react/portainer/policies/components/PolicyOverrideAlert';

import { PageHeader } from '@@/PageHeader';

import { NamespaceDetailsWidget } from './NamespaceDetailsWidget';
import { AccessDatatable } from './AccessDatatable/AccessDatatable';
import { CreateAccessWidget } from './CreateAccessWidget/CreateAccessWidget';
import { useNamespaceAccesses } from './useNamespaceAccesses';

export function AccessView() {
  const {
    params: { id: namespaceName },
  } = useCurrentStateAndParams();
  useUnauthorizedRedirect(
    { authorizations: ['K8sResourcePoolDetailsW'] },
    { to: 'kubernetes.resourcePools' }
  );

  const { hasPolicyApplied, policyId, policyName } =
    useNamespaceAccesses(namespaceName);

  return (
    <>
      <PageHeader
        title="Namespace access management"
        breadcrumbs={[
          { label: 'Namespaces', link: 'kubernetes.resourcePools' },
          {
            label: namespaceName,
            link: 'kubernetes.resourcePools.resourcePool',
            linkParams: { id: namespaceName },
          },
          'Access management',
        ]}
        reload
      />
      {hasPolicyApplied && (
        <div className="row">
          <div className="col-sm-12">
            <PolicyOverrideAlert
              policyName={policyName}
              policyId={policyId}
              policyType="rbac-k8s"
            />
          </div>
        </div>
      )}
      <NamespaceDetailsWidget />
      {!hasPolicyApplied && <CreateAccessWidget />}
      <AccessDatatable />
    </>
  );
}
